module.exports = __webpack_public_path__ + "static/media/dot_FFD600.c76c4fb2.svg";